import { ApolloClient, DocumentNode, OperationVariables, TypedDocumentNode } from '@apollo/client'

export async function paginatedFetchQuery<TData = any, TVariables = OperationVariables>(
  client: ApolloClient<object>,
  queryOptions: {
    query: DocumentNode | TypedDocumentNode<TData, TVariables>
    variables: TVariables
    name: string
    action?: string
    context?: any
  },
  pageSize = 250,
  maxResults = 10000
) {
  let result = []
  let done = false
  while (!done) {
    const { data } = await client.query({
      query: queryOptions.query,
      context: queryOptions.context,
      variables: {
        ...queryOptions.variables,
        from: result.length,
        size: Math.min(pageSize, maxResults - result.length),
        action: queryOptions.action,
      },
    })
    const results_page = data?.[queryOptions.name]
    result.push(...results_page)
    done = !results_page || results_page.length < pageSize
  }
  return result
}
